import { baseUrlClaveUnice, URL_CLAVE_UNICA, siteUrl, ORIGEN, TIPO_USR } from "../../config/config";


const sendRequest = async (path, token, method = "GET", body) => {
  
  
  const params = {
    headers: {
      "Content-Type": "application/json; charset=UTF-8",
      ...(token && {Authorization: `Bearer ${token}`}),
    },
    method,
    ...(body && {body})

  };

    return await fetch(URL_CLAVE_UNICA+path, params)

  
}; 
const get = (user, logout,userLoggedIn) => async (path) => {
  const {access} = user || {};
  try {
  
    const resp = await sendRequest(path, access);
    if(!resp.ok){
      throw resp
    }
    return resp;
  } catch (error) {

    return processResponse(path, "GET", undefined, user, userLoggedIn)(error, logout)
  }
 
};

const processResponse =  (path, method, body, user,userLoggedIn)=> async(error, logout) =>{
  const {refresh} = user || {};
  if(!error){
    return "error"
  }
  try {

    const results = await error.json()

    if(results && results.detail && results.detail.includes("Given token not valid for any token type")){
      let newToken = await refreshToken(refresh)
      if(!newToken.ok){
        logout && logout();
        return error
      }
      const {access:newAccess} = await newToken.json()
      const newUser = {...user, access:newAccess};
      await userLoggedIn(newUser)
      const resp = await sendRequest(path, newAccess, method, body);
      if(!resp.ok){
        logout && logout();
        return error
      }
        return resp;
        
    }
    logout && logout();
    return results;
  } catch (error) {
    logout && logout();
    return error
  }
  
}

//Given token not valid for any token type
const post = (user, logout,userLoggedIn) => async (path, body) => {
  const {access} = user || {}
  try {
    const resp = await sendRequest(path, access, "POST", body);
    if(!resp.ok){
      throw resp
    }
    return resp;
  } catch (error) {
    return processResponse(path, "POST", body, user, userLoggedIn)(error, logout)
  }
};

const put = (user, logout,userLoggedIn) => async (path, body) => {
  const {access} = user || {}
  try {
    const resp = await sendRequest(path, access, "PUT", body);
    if(!resp.ok){
      throw resp
    }
    return resp;
  } catch (error) {
    return processResponse(path, "PUT", body, user, userLoggedIn)(error, logout)
  }
};

const patch = (user, logout,userLoggedIn) => async (path, body) => {
  const {access} = user || {}
  try {
    const resp = await sendRequest(path, access, "PATCH", body);
    if(!resp.ok){
      throw resp
    }
    return resp;
  } catch (error) {
    return processResponse(path, "PATCH", body, user, userLoggedIn)(error, logout)
  }
};

 const refreshToken = async refreshToken => {
  return await post()(`cuenta/api/v1/token/refresh/`, JSON.stringify({refresh:refreshToken}));
};
export const validacedula = async (body) => {
  console.log("cuenta/api/v1/validacedula/", body)
  return await post()(`cuenta/api/v1/validacedula/`, body);
};


export const checkstate = (user) => async (body) => {
  return await post(user)(`api/v1/checkstate/`+ORIGEN+TIPO_USR, body);
};

export const urlclave = async () => {
  return await get()('api/v1/urclave/'+ORIGEN);
};

export const logoutClaveUnica = async () => {
  return window.location.href=baseUrlClaveUnice+'?redirect='+siteUrl;	
};

export const logout = async (user) => {
  const body = JSON.stringify({refresh:user.refresh})
  return post(user)(`cuenta/api/v1/logout/`, body)
};



